import { fetchWithTimeout, handleResponseErrors } from './http'

/**
 * Checks if a feature is on in features data from the back-end
 */
const isFeatureOn = featureName => {
  return function(features) {
    const feature = features && features.data && features.data.length > 0 && features.data.find(a => a.id === featureName)
    return feature && feature.attributes.enabled
  }
}

async function fetchFeatures(setEnvironment, setFeatures, setLoadingFeatures) {
  const featuresUrl = "/api/ssp/features.json"
  try {
    setLoadingFeatures(true)
    const response = await fetchWithTimeout(featuresUrl)
    const body = await response.json()
    handleResponseErrors(response, body)
    setFeatures(body)
    setEnvironment(body.meta.revereEnv)
  } catch (error) {
    setFeatures(null)
    setEnvironment(null)
  } finally {
    setLoadingFeatures(false)
  }
}

export { fetchFeatures, isFeatureOn }
